import { useMutation } from "@tanstack/react-query";

import { guacHttpClient } from "@/lib/http";
import {
  HttpResponse,
  SadieVoiceSipRequest,
  SadieVoiceSipSetup,
} from "@/types";

/** Saves the Live setup that calls to guac's number are answered with. */
export function useSaveSadieVoicePhoneCall() {
  return useMutation({
    mutationFn: async (request: SadieVoiceSipRequest) => {
      const res = await guacHttpClient.post<
        SadieVoiceSipSetup,
        HttpResponse<SadieVoiceSipSetup>
      >("relationships/simulate/voice/sip", request);
      return res.data;
    },
  });
}
